import { MutationTree } from 'vuex'
import { MutationTypes } from '@/store/global/mutations-types'
import { State } from './state'

export type Mutations<S = State> = {
    [MutationTypes.SET_IS_MOBILE](state: S, payload: boolean): void
}

export const mutations: MutationTree<State> & Mutations = {
    [MutationTypes.SET_IS_MOBILE](state, payload: boolean) {
        state.isMobile = payload
    },
}